// We need to initialize common page elements,
// as this entrypoint isn't initialized by the main application.js
import "entry/common"

import currentRegion from "lib/currentRegion"
import rememberRegion from "lib/rememberRegion"
import renderPromos from "promos/renderPromos"
import { initializeCommonPageElements } from "pages/common"

async function initialize() {
  const region = await currentRegion().catch(() => "no-region")

  initializeCommonPageElements()
  rememberRegion()
  renderPromos({ region })
}

// Now, let's export the entrypoint initializer, so it's available for the
// `js_page` ERB yield block
TC.EntrypointInitializer = initialize
